import React, { useEffect, useState } from "react";
import axios from "axios";
import { FiArrowLeft } from 'react-icons/fi';
import { useNavigate, useLocation } from "react-router-dom";  // 페이지 이동을 위해 useNavigate 사용

const FeeManager = () => {

    const navigate = useNavigate(); // useNavigate 훅 사용
    
    const location = useLocation();
    const type = location.state?.type || {};  // 없을 수도 있으니 fallback 필요

    const [activeTab, setActiveTab] = useState("register");
    const [editData, setEditData] = useState(null);
    const [planList, setPlanList] = useState([]);

    const [planName, setPlanName] = useState("");
    const [price, setPrice] = useState("");
    const [token, setToken] = useState("");
    const [planType, setPlanType] = useState("basic");
    const [billingCycle, setBillingCycle] = useState("1");
    const [message, setMessage] = useState("");

    const isEdit = !!editData;

    // ✅ 요금제 목록 불러오기
    const fetchPlans = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_FASTAPI_ADS_URL}/plan/list`);

            setPlanList(res.data || []);
        } catch (err) {
            console.error("목록 조회 실패", err);
        }
    };

    useEffect(() => {
        fetchPlans();
    }, []);

    useEffect(() => {
        if (isEdit) {
            setPlanName(editData.ticket_name);
            setPrice(editData.ticket_price.toString());
            setPlanType(editData.ticket_type);
            setBillingCycle(editData.billing_cycle?.toString() || "1");
            setToken(editData.token_amount.toString());
        }
    }, [editData, isEdit]);

    const handleSubmit = async () => {
        if (!planName || !price) {
            setMessage("모든 필드를 입력해주세요.");
            return;
        }

        const payload = {
            ticket_type: planType,
            ticket_name: planName,
            ticket_price: Number(price),
            billing_cycle: planType !== "basic" ? Number(billingCycle) : null,
            token_amount: Number(token),
        };

        try {
            if (isEdit) {
                await axios.put(`${process.env.REACT_APP_FASTAPI_ADS_URL}/ads/plan/update/${editData.id}`, payload);
                setMessage("요금제가 수정되었습니다.");
            } else {
                await axios.post(`${process.env.REACT_APP_FASTAPI_ADS_URL}/plan/save`, payload);
                setMessage("요금제가 등록되었습니다.");
            }

            setEditData(null);
            setPlanName("");
            setPrice("");
            setPlanType("basic");
            setBillingCycle("1");
            setToken("");
            fetchPlans(); // 새로고침
        } catch (err) {
            console.error("저장 오류", err);
            setMessage("저장 중 오류 발생");
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("정말 삭제하시겠습니까?")) return;
        try {
            await axios.delete(`${process.env.REACT_APP_FASTAPI_ADS_URL}/plan/delete/${id}`);
            fetchPlans();
        } catch (err) {
            console.error("삭제 실패", err);
        }
    };

    const handleBack = () => {
        navigate("/ads/admin", { state: { type: type } });
    }

    return (
        <div className="max-w-3xl mx-auto p-6">
            <button
                                onClick={handleBack}
                                className="flex items-center text-gray-600 hover:text-black mb-4"
                            >
                                <FiArrowLeft className="mr-2 text-xl" />
                                <span>뒤로 가기</span>
                            </button>
            {/* 탭 */}
            <div className="flex gap-4 mb-6">
                <button
                    onClick={() => {
                        setActiveTab("register");
                        setEditData(null);
                        setMessage("");
                    }}
                    className={`${activeTab === "register" ? "font-bold border-b-2 border-blue-600" : ""}`}
                >
                    요금제 등록
                </button>
                <button
                    onClick={() => {
                        setActiveTab("edit");
                        setMessage("");
                    }}
                    className={`${activeTab === "edit" ? "font-bold border-b-2 border-blue-600" : ""}`}
                >
                    요금제 수정
                </button>
            </div>

            {/* 등록 or 수정 폼 */}
            {activeTab === "register" || isEdit ? (
                <div className="space-y-4">
                    <div>
                        <label className="block font-medium">요금제 이름</label>
                        <input className="w-full border px-4 py-2 rounded" value={planName} onChange={(e) => setPlanName(e.target.value)} />
                    </div>
                    <div>
                        <label className="block font-medium">가격</label>
                        <input type="number" className="w-full border px-4 py-2 rounded" value={price} onChange={(e) => setPrice(e.target.value)} />
                    </div>
                    <div>
                        <label className="block font-medium">유형</label>
                        <select value={planType} onChange={(e) => setPlanType(e.target.value)} className="w-full border px-4 py-2 rounded">
                            <option value="basic">베이직</option>
                            <option value="standard">스탠다드</option>
                            <option value="premium">프리미엄</option>
                        </select>
                    </div>
                    {(planType === "standard" || planType === "premium") && (
                        <div>
                            <label className="block font-medium">구독 주기</label>
                            <select value={billingCycle} onChange={(e) => setBillingCycle(e.target.value)} className="w-full border px-4 py-2 rounded">
                                <option value="1">월</option>
                                <option value="12">년</option>
                            </select>
                        </div>
                    )}
                    <div>
                        <label className="block font-medium">지급 토큰 수</label>
                        <input type="number" className="w-full border px-4 py-2 rounded" value={token} onChange={(e) => setToken(e.target.value)} />
                    </div>

                    {message && <p className="text-sm text-blue-600">{message}</p>}

                    <button className="w-full bg-blue-600 text-white py-2 rounded" onClick={handleSubmit}>
                        {isEdit ? "수정하기" : "등록하기"}
                    </button>
                </div>
            ) : null}

            {/* 수정 탭 목록 */}
            {activeTab === "edit" && !isEdit && (
                <div className="pt-8">
                    <table className="w-full border">
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="border p-2">이름</th>
                                <th className="border p-2">가격</th>
                                <th className="border p-2">유형</th>
                                <th className="border p-2">토큰</th>
                                <th className="border p-2">주기</th>
                                <th className="border p-2">수정</th>
                                <th className="border p-2">삭제</th>
                            </tr>
                        </thead>
                        <tbody>
                            {planList.map((plan) => (
                                <tr key={plan.TICKET_ID}>
                                    <td className="border p-2">{plan.TICKET_NAME}</td>
                                    <td className="border p-2">{plan.TICKET_PRICE}</td>
                                    <td className="border p-2">{plan.TICKET_TYPE}</td>
                                    <td className="border p-2">{plan.TOKEN_AMOUNT}</td>
                                    <td className="border p-2">
                                        {plan.BILLING_CYCLE ? (plan.BILLING_CYCLE === 12 ? "년" : "월") : "-"}
                                    </td>
                                    <td className="border p-2">
                                        <button onClick={() => setEditData(plan)} className="text-blue-500">수정</button>
                                    </td>
                                    <td className="border p-2">
                                        <button onClick={() => handleDelete(plan.TICKET_ID)} className="text-red-500">삭제</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>
                </div>
            )}
        </div>
    );
};

export default FeeManager;
